






























































































import { Vue, Component, Ref } from "vue-property-decorator";
import CPage from "@/components/form/CustomPage/CPage.vue";
import StudentForm from "@/components/students/StudentForm.vue";
import CPageButtons from "@/components/form/CustomPage/CPageButtons.vue";
import {
  Student as IStudent,
  StudentEdit as IStudentEdit
} from "@/api-v2/course/models";
import { courseApi, studentDocumentApi } from "@/getinfo-api";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { Student as IStudentDocInfo } from "@/api-v2/student-document-info/models/student";
import StudentDocInfoEducation from "@/components/students/StudentDocInfoEducation.vue";
import StudentDocInfoPassport from "@/components/students/StudentDocInfoPassport.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import CField from "@/components/form/CField.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";

@Component({
  components: {
    CBlock,
    CField,
    CustomButton,
    StudentDocInfoPassport,
    StudentDocInfoEducation,
    CPageButtons,
    StudentForm,
    CPage
  }
})
export default class StudentEdit extends Vue {
  @Ref("educationForm") educationForm?: StudentDocInfoEducation;
  @Ref("passportForm") passportForm?: StudentDocInfoPassport;
  student!: IStudent;
  studentDocumentInfo!: IStudentDocInfo;
  isLoading: boolean = false;
  form!: IStudentEdit;

  data() {
    return {
      student: undefined,
      studentDocumentInfo: undefined,
      form: undefined
    };
  }

  get fullName() {
    return this.student
      ? `${this.student.lastName} ${this.student.firstName} ${
          this.student.middleName ? this.student.middleName : ""
        }`
      : "";
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "students" },
        label: this.$tc(this.$translate.Students)
      },
      {
        to: {
          name: "student",
          params: { id: this.student ? this.student.id : "" }
        },
        label: this.fullName
      },
      {
        label: this.$tc(this.$translate.Edit)
      }
    ];
  }

  async editStudentDocumentInfo() {
    this.isLoading = true;
    try {
      this.studentDocumentInfo.education = this.educationForm?.docInfoEducation;
      this.studentDocumentInfo.passport = this.passportForm?.docInfoPassport;

      await studentDocumentApi.editStudent(
        this.studentDocumentInfo.id,
        this.studentDocumentInfo
      );

      await this.$router.push({
        name: "student",
        params: { id: this.student.id }
      });
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLoading = false;
    }
  }

  async editStudent() {
    try {
      await courseApi.Student.editStudent(this.student.id, this.form);
      await this.editStudentDocumentInfo();
    } catch (err) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: err.response
      });
    } finally {
      this.isLoading = false;
    }
  }

  remove() {
    this.isLoading = true;
    courseApi.Student.deleteStudent(this.student.id)
      .finally(() => {
        this.isLoading = false;
        this.$router.push({ name: "students" });
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  decline() {
    this.$router.go(-1);
  }

  created() {
    this.isLoading = true;
    courseApi.Student.getStudent(this.$route.params.id)
      .then(async res => {
        this.student = res.data;
        const { data } = await studentDocumentApi.getStudent(this.student?.id);
        this.studentDocumentInfo = data;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
